import { render, staticRenderFns } from "./prepressmap.vue?vue&type=template&id=0c04a0d8&"
import script from "./prepressmap.vue?vue&type=script&lang=js&"
export * from "./prepressmap.vue?vue&type=script&lang=js&"
import style0 from "./prepressmap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports